import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowLeft, ShoppingBag } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="pt-32 md:pt-40 pb-24 min-h-screen relative overflow-hidden" data-testid="payment-cancel-page">
      <div className="aurora" style={{ width: 480, height: 480, background: "#FECACA", top: "5%", left: "-8%" }} />
      <div className="max-w-2xl mx-auto px-6 relative text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          className="rounded-[2rem] bg-white border border-[#FECACA] p-10 md:p-14"
        >
          <div className="text-6xl mb-4">☁️</div>
          <h1 className="font-display font-semibold text-3xl md:text-4xl text-[#051937]">
            Duszek chwilę wstrzymał zakup.
          </h1>
          <p className="mt-4 text-[#0b2a55]/80">
            Płatność została anulowana. Jeśli była to pomyłka — nic straconego. Możesz wrócić do koszyka.
          </p>
          <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
            <Link
              to="/"
              data-testid="cancel-home"
              className="inline-flex items-center gap-2 rounded-full bg-[#051937] text-white px-6 py-3 font-semibold"
            >
              <ArrowLeft size={16} /> Strona główna
            </Link>
            <Link
              to="/sklep"
              className="inline-flex items-center gap-2 rounded-full bg-white border border-[#BAE6FD] text-[#051937] px-6 py-3 font-semibold"
            >
              Wróć do sklepu <ShoppingBag size={16} />
            </Link>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
